<template>
  <pdl-collapse-item :name="name">
    <div slot="title" class="heading heading--sm" qaid="warehouse.heading">
      {{ warehouse.name }} ({{ warehouse.totalQuantity }})
    </div>

    <slot name="info">
      <div class="grid-x">
        <div v-cloak class="cell large-4" qaid="warehouse.infoText">
          <p>{{ bp('infoText') }}</p>
        </div>
      </div>
    </slot>

    <grid-container>
      <table class="b2b-grid b2b-grid--collapse is-compact" qaid="allocated-items-sku-grid">
        <thead class="b2b-grid__header" qaid="warehouse.grid.head">
          <th class="b2b-grid__cell b2b-grid__head" qaid="warehouse.grid.checkBox">
            <label class="checkbox mb-0">
              <input
                id="selectAllItems"
                v-model="allSelected"
                type="checkbox"
                :disabled="isOnHold"
                @change="selectAllItems"
              />
              <span class="control-indicator"></span>
            </label>
          </th>
          <th
            v-for="header in getHeaders()"
            :key="header.label"
            class="b2b-grid__cell b2b-grid__head"
            :qaid="qaLabel(header.label)"
          >
            {{ header.label }}
          </th>
        </thead>

        <tbody qaid="warehouse.grid.body">
          <template v-for="item in paginatedData">
            <warehouse-item
              :key="item.id"
              :item="item"
              :warehouse="warehouse"
              :headers="headers"
              :base-properties="baseProperties"
              @toggle-selection="updateItemsSelection"
            />
          </template>
        </tbody>
      </table>
    </grid-container>
    <pagination
      v-if="pageCount > 1"
      ref="pagination"
      :page-number="pageNumber"
      :page-count="pageCount"
      @page-change="pageChange"
      @prev-page="prevPage"
      @next-page="nextPage"
    >
    </pagination>
  </pdl-collapse-item>
</template>

<script>
import pagination from '@/mixins/pagination';
import {mapGetters, mapMutations} from 'vuex';
import {PdlCollapseItem} from '@pedal/pdl-collapse';
import GridContainer from '@/components/grid/GridContainer';
import WarehouseItem from '@/components/containers/checkout/WarehouseItem';
import Pagination from '@/components/Pagination';

export default {
  components: {PdlCollapseItem, GridContainer, WarehouseItem, Pagination},

  mixins: [pagination],

  props: {
    size: {
      type: Number,
      required: false,
      default: ACC.allocatedItemsPageSize || 6,
    },
    warehouse: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    headers: {
      type: Array,
      default: () => [],
    },
    isOnHold: Boolean,
    baseProperties: {
      type: Array,
      default: () => [],
      required: false,
    },
  },

  data() {
    return {
      allSelected: false,
      listData: this.warehouse.allocatedItems,
      updateItemCallCount: 0,
    };
  },

  computed: {
    isAllSelected() {
      return this.warehouse.allocatedItems?.every(item => item.selected);
    },

    isAllSelectable() {
      return this.warehouse.allocatedItems?.every(item => item.isAllowedToShip);
    },

    name() {
      return `${this.type}-${this.warehouse.id}`;
    },

    ...mapGetters('backend', ['consumerFriendlyMode']),
  },

  watch: {
    isAllSelected: {
      immediate: true,
      handler() {
        this.allSelected = this.isAllSelected;
      }
    },
  },

  methods: {
    updateItemsSelection() {
      this.$emit('update-selection');
    },

    selectAllItems() {
      const newState = this.allSelected;

      this.warehouse.allocatedItems
          ?.filter(item => item.isAllowedToShip && !this.warehouse.isOnHold)
          ?.forEach((item) => {
            item.selected = newState;
          });

      this.updateItemsSelection();
    },

    qaLabel(label) {
      let prefix = 'warehouse.grid.column';
      let strippedLabel = label ? '.' + label.replace(/[^0-9a-z]/gi, '') : '';

      return prefix + strippedLabel;
    },

    getHeaders() {
      return this.headers.filter((header) => {
        if (this.consumerFriendlyMode && (header.label == 'Price' || header.label == 'Subtotal')) {
          return false;
        } else {
          return true;
        }
      });
    },
    ...mapMutations('cart', ['setHasAllocatedItemsProcessing']),
  },
};
</script>
